export const NAV_BAR_LINKS = [
  {
    key: "bookings",
    label: "Bookings",
    path: "/admin",
  },
];
